import { useParams, useSearchParams } from 'react-router-dom';

import { OrganizationSettingsPage } from '~/components/pages/OrganizationSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationSettingsRoute: React.FC = () => {
  const { organizationId } = useParams();
  const [searchParams] = useSearchParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OrganizationSettingsPage
        organizationId={organizationId}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        cancelUrl={searchParams.get('cancelUrl') ?? undefined}
      />
    </DashboardTemplate>
  );
};
